import { MODAL_TIER_REGISTER } from '@/atoms/modalTierRegister';
import { Tier, evaluateTierGate, type TierGateContext } from '@/lib/modalTiers';
import { type QueuedModal } from '@/types/modal-queue.types';
import { type ModalId } from '@heidi/schema/ml-scribe';

/**
 * Human-readable tier verdict for the queue-top modal, for the dev panel. Mirrors
 * the queue gate (`isModalDisplayAllowedByTier`): unmapped → pass-through, else the
 * tier + `evaluateTierGate` outcome. `register` is injectable for tests, matching
 * that helper's seam.
 */
export const describeQueueTopVerdict = (
  queueTop: QueuedModal | null,
  enabled: boolean,
  ctx: TierGateContext,
  register: Partial<Record<ModalId, Tier>> = MODAL_TIER_REGISTER
): string => {
  if (!queueTop) return '—';
  const tier = register[queueTop.id];
  if (tier === undefined) return 'unmapped → pass-through';

  const label = `T${tier} ${Tier[tier]}`;
  if (!enabled) return `${label} (framework off)`;

  const result = evaluateTierGate(tier, ctx);
  return result.allowed ? `${label} → allowed` : `${label} → withheld (${result.reason})`;
};
